import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ICONS } from "./icons";

@Component({
  selector: "app-icon",
  templateUrl: "./icon.component.html",
  styleUrls: ["./icon.component.css"],
})
export class IconComponent implements OnChanges {
  @Input() name!: keyof typeof ICONS;
  @Input() size = 18;

  icon!: SafeHtml;

  constructor(private sanitizer: DomSanitizer) {}
  hasStroke = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["name"]) {
      const rawIcon = ICONS[this.name];

      this.hasStroke = rawIcon.includes("stroke=");
      this.icon = this.sanitizer.bypassSecurityTrustHtml(rawIcon);
    }
  }
}
